import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import styles from './VcompCompnents.module.css'
import { useDispatch, useSelector } from "react-redux";
import { deleteVcompProjectsWithConnections, getProjects, setCollabMcqModalIdProject, setCollabMcqModalVisibility, setCollabProjectFormVisibility, setOnAnswerProject, setProjectModalVisible } from "./vcompSlice";
import noImageIcon from '../../assets/images/noImageProject.png'
import Langs from "../../app/lang/langs";
import moment from "moment/moment";
import { setOnCreateProject, setProjectMode, setCreateProjectModalVisible } from "./vcompSlice";
import { ThemeButton } from '../../components/buttons/ThemeButton'
import { Badge } from 'primereact/badge';
import { isAdmin } from "../../app/utils/helpers";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

// MUI imports for mobile layout
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import Divider from '@mui/material/Divider';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import QuizOutlinedIcon from '@mui/icons-material/QuizOutlined';



export default function ProjectCard(props) {

    const project = props.project;
    const manage = props.manage;
    const dispatch = useDispatch()

    const isMobile = useSelector((state) => state.settings.isMobile)
    const userRoleId = useSelector((state) => state.login.userRoleId)
    const [mobileExpanded, setMobileExpanded] = useState(false)

    const handleCardClick = () => {
        if (manage) {
            dispatch(setOnCreateProject({
                ...project, image_src:
                    project.imgsrc,
                start_date: moment(project.start_date, 'DD/MM/YYYY').toDate(),
                end_date: project.end_date ? moment(project.end_date, 'DD/MM/YYYY').toDate() : null,
                days_limit: project.days_limit / 7
            }));
            dispatch(setProjectMode("edit"));
            dispatch(setCreateProjectModalVisible(true));
        } else {
            if (statusReturn(project) === 'On going') {
                dispatch(setCollabProjectFormVisibility(true));
                dispatch(setOnAnswerProject(project))
            }
        }
    };

    const deleteProject = (id, nom) => {
        confirmDelete(id, nom);
    }
    const confirmDelete = (id, nom) => {
        confirmDialog({
            message: `Voulez-vous supprimer * ${nom} * projet ? Cette action est irréversible.`,
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger rounded',
            rejectClassName: 'p-button-secondary rounded me-2',
            acceptIcon: 'pi pi-trash',
            acceptLabel: 'Effacer',
            rejectLabel: 'Annuler',
            accept: () => accept(id),
            reject
        });
    };
    const accept = (id) => {
        dispatch(deleteVcompProjectsWithConnections({ id_project: id }))
            .then(() => {
                dispatch(getProjects())
            })
    }
    const reject = () => {
    }


    const statusReturn = (project) => {
        const now = moment()
        const startDate = moment(project.start_date, 'DD/MM/YYYY')
        const endDate = project.end_date ? moment(project.end_date, 'DD/MM/YYYY') : null
        if (project.active !== 1) {
            return 'Inactif'
        }
        if (endDate && endDate < now) {
            return 'Finalized'
        }
        if (startDate > now) {
            return 'Upcoming'
        }
        if (startDate < now) {
            return 'On going'
        }
        return 'no data'
    }

    const getStatusStyle = (status) => {
        switch (status) {
            case 'On going':
                return { color: '#16a34a', fontWeight: 600 };
            case 'Inactif':
                return { color: '#dc2626', fontWeight: 600 };
            case 'Upcoming':
                return { color: '#1179be', fontWeight: 600 };
            case 'Finalized':
                return { color: '#d97706', fontWeight: 600 };
            default:
                return { color: '#8b92a0' };
        }
    }

    const handleMcqModalOpen = () => {
        if (project) {
            dispatch(setCollabMcqModalVisibility(true))
            dispatch(setCollabMcqModalIdProject(project.id))
        }
    }

    const currentStatus = statusReturn(project);

    const infoValueStyle = {
        color: 'rgb(255, 144, 21)',
        fontWeight: 500,
    };

    const infoRowStyle = {
        color: '#4b5263',
        fontSize: '13px',
        transition: 'color 0.2s ease',
        borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
        paddingTop: '6px',
        paddingBottom: '6px',
    };

    const dividerStyle = {
        borderColor: 'rgba(0, 0, 0, 0.07)',
    };

    const sectionLabelStyle = {
        color: '#8b92a0',
        fontSize: '11.5px',
        fontWeight: 500,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
    };

    // --- Status chip color mapping for mobile ---
    const getStatusChipColor = (status) => {
        switch (status) {
            case 'On going': return 'success';
            case 'Inactif': return 'error';
            case 'Upcoming': return 'info';
            case 'Finalized': return 'warning';
            default: return 'default';
        }
    };

    // --- Mobile info row helper ---
    const MobileInfoRow = ({ label, value, valueSx }) => (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 0.75 }}>
            <Typography sx={{ color: '#8b92a0', fontSize: '0.75rem', fontWeight: 500, letterSpacing: '0.04em', textTransform: 'uppercase' }}>
                {label}
            </Typography>
            <Typography sx={{ fontSize: '0.8125rem', fontWeight: 500, color: '#111318', ...valueSx }}>
                {value}
            </Typography>
        </Box>
    );

    // =============================================
    //  MOBILE LAYOUT (isMobile === 2)
    // =============================================
    if (isMobile === 2) {
        return (
            <Card
                sx={{
                    mb: 1.5,
                    borderRadius: '14px',
                    border: '1px solid rgba(0, 0, 0, 0.08)',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.04)',
                    overflow: 'hidden',
                    position: 'relative',
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        height: '2px',
                        background: 'linear-gradient(90deg, transparent 10%, rgba(255, 144, 21, 0.35) 50%, transparent 90%)',
                        zIndex: 1,
                    },
                    '&:active': {
                        transform: 'scale(0.99)',
                    },
                    transition: 'transform 0.15s ease-in-out, box-shadow 0.2s ease',
                }}
            >
                {/* Main card row - tappable */}
                <CardActionArea
                    onClick={handleCardClick}
                    disabled={!manage && currentStatus !== 'On going'}
                    sx={{
                        p: 1.5,
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                        '&:active': { transform: 'scale(0.97)' },
                    }}
                >
                    {/* Left: Avatar */}
                    <Avatar
                        src={project.imgsrc ?? noImageIcon}
                        alt={project.nom}
                        variant="rounded"
                        sx={{
                            width: 48,
                            height: 48,
                            borderRadius: '10px',
                            bgcolor: 'rgba(0,0,0,0.02)',
                            border: '1px solid rgba(0,0,0,0.06)',
                            mr: 1.5,
                            flexShrink: 0,
                            '& img': { objectFit: 'contain', p: 0.5 },
                        }}
                    />

                    {/* Center: Name, status chip, date */}
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography
                            sx={{
                                fontWeight: 600,
                                fontSize: '0.9375rem',
                                color: '#111318',
                                lineHeight: 1.3,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {project && project.nom}
                        </Typography>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mt: 0.5, flexWrap: 'wrap' }}>
                            <Chip
                                label={<Langs str={currentStatus} />}
                                color={getStatusChipColor(currentStatus)}
                                size="small"
                                sx={{
                                    height: 22,
                                    fontSize: '0.6875rem',
                                    fontWeight: 600,
                                    letterSpacing: '0.02em',
                                }}
                            />
                            {!manage && project.activate_mcq == 1 && (
                                <Chip
                                    icon={<QuizOutlinedIcon sx={{ fontSize: 14 }} />}
                                    label={<Langs str="TAKE_MCQ" />}
                                    size="small"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleMcqModalOpen();
                                    }}
                                    sx={{
                                        height: 22,
                                        fontSize: '0.6875rem',
                                        fontWeight: 600,
                                        background: 'linear-gradient(135deg, #FF8701, #FFC100)',
                                        color: '#fff',
                                        letterSpacing: '0.03em',
                                        '& .MuiChip-icon': { color: '#fff' },
                                        '&:active': { transform: 'scale(0.95)' },
                                    }}
                                />
                            )}
                        </Box>

                        <Typography sx={{ color: '#8b92a0', fontSize: '0.75rem', mt: 0.5 }}>
                            {project && project.start_date}
                            {project && project.end_date ? ` — ${project.end_date}` : ''}
                        </Typography>
                    </Box>

                    {/* Right: Action hint */}
                    <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0, ml: 0.5 }}>
                        {manage ? (
                            <Button
                                variant="contained"
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleCardClick();
                                }}
                                sx={{
                                    minWidth: 0,
                                    minHeight: 36,
                                    px: 2,
                                    borderRadius: '999px',
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    fontSize: '0.75rem',
                                    bgcolor: '#FF9015',
                                    color: '#fff',
                                    boxShadow: '0 2px 8px rgba(255,144,21,0.25)',
                                    '&:hover': { bgcolor: '#e67e00' },
                                    '&:active': { transform: 'scale(0.95)' },
                                }}
                            >
                                <Langs str="Manage" />
                            </Button>
                        ) : (
                            currentStatus === 'On going' ? (
                                <ChevronRightIcon sx={{ color: '#FF9015', fontSize: 24 }} />
                            ) : (
                                <ChevronRightIcon sx={{ color: '#ccc', fontSize: 24 }} />
                            )
                        )}
                    </Box>
                </CardActionArea>

                {/* Info rows - always visible */}
                <Box sx={{ px: 2, pb: manage ? 0 : 1.5 }}>
                    <Divider sx={{ mb: 1 }} />
                    <MobileInfoRow label={<Langs str="DELAY" />} value={<><span style={{ color: 'rgb(255,144,21)', fontWeight: 500 }}>{project && project.days_limit / 7}</span> <span style={{ color: '#8b92a0' }}>semaine(s)</span></>} />
                    <MobileInfoRow label={<><Langs str="Session no" />&deg;</>} value={<span style={{ color: 'rgb(255,144,21)', fontWeight: 500 }}>{project && project.last_session_number + 1}</span>} />
                </Box>

                {/* Manage-only expandable section */}
                {manage && (
                    <>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                py: 0.25,
                            }}
                        >
                            <IconButton
                                onClick={() => setMobileExpanded(!mobileExpanded)}
                                size="small"
                                sx={{
                                    minWidth: 44,
                                    minHeight: 44,
                                    color: '#8b92a0',
                                    transition: 'color 0.2s',
                                    '&:hover': { color: '#FF9015' },
                                }}
                                aria-label={mobileExpanded ? "Réduire" : "Détails"}
                            >
                                {mobileExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </IconButton>
                        </Box>
                        <Collapse in={mobileExpanded} timeout={250}>
                            <Box sx={{ px: 2, pb: 2 }}>
                                <Divider sx={{ mb: 1 }} />
                                <MobileInfoRow label={<Langs str="ID" />} value={<span style={{ color: 'rgb(255,144,21)', fontWeight: 500 }}>{project && project.id}</span>} />
                                <MobileInfoRow label={<Langs str="CURRENT_COLLABS_NUMBER" />} value={<span style={{ color: 'rgb(255,144,21)', fontWeight: 500 }}>{project && project.collabs_count}</span>} />
                                <MobileInfoRow label={<Langs str="NEEDED_COLLABS_NUMBER" />} value={<span style={{ color: 'rgb(255,144,21)', fontWeight: 500 }}>{project && project.needed_collabs_number}</span>} />

                                {isAdmin(userRoleId) && (
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1.5 }}>
                                        <Button
                                            variant="outlined"
                                            color="error"
                                            size="small"
                                            startIcon={<DeleteOutlineIcon sx={{ fontSize: 16 }} />}
                                            onClick={() => deleteProject(project.id, project.nom)}
                                            sx={{
                                                minHeight: 44,
                                                borderRadius: '999px',
                                                textTransform: 'none',
                                                fontWeight: 600,
                                                fontSize: '0.75rem',
                                                px: 2,
                                                borderColor: 'rgba(220,38,38,0.3)',
                                                color: '#dc2626',
                                                '&:hover': {
                                                    borderColor: '#dc2626',
                                                    bgcolor: 'rgba(220,38,38,0.06)',
                                                },
                                                '&:active': { transform: 'scale(0.95)' },
                                            }}
                                        >
                                            <Langs str="DELETE" />
                                        </Button>
                                    </Box>
                                )}
                            </Box>
                        </Collapse>
                    </>
                )}
            </Card>
        );
    }

    // =============================================
    //  DESKTOP LAYOUT (original)
    // =============================================
    return (
        <Col lg={6} xl={4} xxl={3} className="p-3">
            <div className={`card p-0 ${styles.projectCard}`}>
                <Row className="card-body" style={{ position: 'relative', zIndex: 1 }}>
                    <Col lg={12} className="d-flex justify-content-end" style={{ padding: '8px 12px 0' }}>
                        {!manage && project.activate_mcq == 1 &&
                            <Badge
                                style={{
                                    cursor: 'pointer',
                                    background: 'linear-gradient(135deg, #FF8701, #FFC100)',
                                    border: 'none',
                                    borderRadius: '9999px',
                                    padding: '0px 14px',
                                    fontSize: '11px',
                                    fontWeight: 600,
                                    letterSpacing: '0.5px',
                                    textTransform: 'uppercase',
                                    color: '#fff',
                                    boxShadow: '0 2px 10px rgba(255, 144, 21, 0.25)',
                                    transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                                severity="danger"
                                value={<Langs str="TAKE_MCQ" />}
                                onClick={() => { handleMcqModalOpen() }}
                            ></Badge>
                        }
                    </Col>
                    <Col lg={12} className={`card-title text-center pb-4 ${styles.textShadow}`} style={{ ...dividerStyle, borderBottom: '1px solid rgba(0, 0, 0, 0.07)' }}>
                        {project && project.nom}
                    </Col>

                    <Col lg={6} className="py-4 d-flex justify-content-center" style={{ ...dividerStyle, borderBottom: '1px solid rgba(0, 0, 0, 0.07)' }}>
                        <div className={styles.projectImageSection}>
                            <img src={project.imgsrc ?? noImageIcon} className={styles.projectLogo} alt="project-icon" />
                        </div>
                    </Col>
                    <Col lg={6} className={isMobile == 2 ? "py-4 row d-flex justify-content-center" : "py-4 row"} style={{ ...dividerStyle, borderBottom: '1px solid rgba(0, 0, 0, 0.07)' }}>
                        <Col lg={12} className="p-0" style={{ marginBottom: '8px' }}>
                            <p style={{ color: '#4b5263', fontSize: '13px', margin: 0 }}>
                                Status: <span style={getStatusStyle(currentStatus)}> <Langs str={currentStatus} /> </span>
                            </p>
                        </Col>
                        <Col xs={12} className="p-0">
                            <ThemeButton
                                onClick={() => handleCardClick()}
                                className=''
                                title={manage ? <Langs str="Manage" /> : <Langs str="Respond" />}
                                active={true}
                                color="red"
                            />
                        </Col>
                    </Col>
                    <Col lg={12} className="row px-2 py-2" style={{ paddingTop: '8px' }}>
                        <Col lg={12} className="d-flex justify-content-between" style={infoRowStyle}>
                            <span style={sectionLabelStyle}><Langs str="START_DATE" /></span> <p style={{ margin: 0, color: '#111318' }}>{project && project.start_date}</p>
                        </Col>
                        {project && project.end_date &&
                            <Col lg={12} className="d-flex justify-content-between" style={infoRowStyle}>
                                <span style={sectionLabelStyle}><Langs str="END_DATE" /></span> <p style={{ margin: 0, color: '#111318' }}>{project && project.end_date}</p>
                            </Col>
                        }
                        <Col lg={12} className="d-flex justify-content-between" style={infoRowStyle}>
                            <span style={sectionLabelStyle}><Langs str="DELAY" /></span> <p style={{ margin: 0 }}><span style={infoValueStyle}>{project && project.days_limit / 7}</span> <span style={{ color: '#8b92a0' }}>semaine(s)</span></p>
                        </Col>
                        <Col lg={12} className="d-flex justify-content-between" style={infoRowStyle}>
                            <span style={sectionLabelStyle}><Langs str="Session no" />&deg;</span><p style={{ margin: 0 }}><span style={infoValueStyle}>{project && project.last_session_number + 1}</span></p>
                        </Col>
                        {manage && <Col lg={12} className="d-flex justify-content-between" style={infoRowStyle}>
                            <span style={sectionLabelStyle}><Langs str="ID" /></span><p style={{ margin: 0 }}><span style={infoValueStyle}>{project && project.id}</span></p>
                        </Col>}
                        {manage && <Col lg={12} className="d-flex justify-content-between" style={infoRowStyle}>
                            <span style={sectionLabelStyle}><Langs str="CURRENT_COLLABS_NUMBER" /></span><p style={{ margin: 0 }}><span style={infoValueStyle}>{project && project.collabs_count}</span></p>
                        </Col>}
                        {manage && <Col lg={12} className="d-flex justify-content-between" style={infoRowStyle}>
                            <span style={sectionLabelStyle}><Langs str="NEEDED_COLLABS_NUMBER" /></span><p style={{ margin: 0 }}><span style={infoValueStyle}>{project && project.needed_collabs_number}</span></p>
                        </Col>}
                        {manage && isAdmin(userRoleId) && <Col lg={12} className="d-flex justify-content-end" style={{ paddingTop: '12px' }}>
                            <p style={{ margin: 0 }}><span className={styles.deleteTextCard} onClick={() => { deleteProject(project.id, project.nom) }}><Langs str="DELETE" /></span></p>
                        </Col>}


                    </Col>
                </Row>
            </div>
        </Col>
    )
}
